export default "__VITE_ASSET__fc198023__"